/* eslint-disable import/prefer-default-export */
/**
 * All selectable form field types in the CMS (ContentfulCampaignFormField)
 */
export enum CampaignFormFieldType {
  FirstName = 'firstName',
  LastName = 'lastName',
  Email = 'email',
  PcoNumber = 'pcoNumber',
  RenewalDate = 'renewalDate',
  Reasons = 'reasons',
  HomeAutoRenewalDate = 'homeAutoRenewalDate',
}
